import { render, staticRenderFns } from "./jstd.vue?vue&type=template&id=dc29deb8&scoped=true&"
import script from "./jstd.vue?vue&type=script&lang=js&"
export * from "./jstd.vue?vue&type=script&lang=js&"
import style0 from "./jstd.vue?vue&type=style&index=0&id=dc29deb8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc29deb8",
  null
  
)

export default component.exports